module.exports = __webpack_public_path__ + "media/images/guide-thumb-8t-eb9fd88fc7fad982592e702a6dc5bd62.png";